/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_BodyInputs */

const en_consent_body = /** @type {(inputs: Consent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use PostHog to understand how this site is used. Until you choose, nothing is stored on your device and visits are counted anonymously. Accepting lets us recognise your browser across visits.`)
};

/**
* | output |
* | --- |
* | "We use PostHog to understand how this site is used. Until you choose, nothing is stored on your device and visits are counted anonymously. Accepting lets us ..." |
*
* @param {Consent_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_body = /** @type {((inputs?: Consent_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_body(inputs)
});